import BackButtonToolbar from "features/BackButtonToolbar";
import { Show, SimpleShowLayout } from "react-admin";
import StudentInfoSection from "./StudentInfoSection";
import RequestInfoSection from "./RequestInfoSection";

const ShowAcademicRequestDataIssue = () => (
  <Show
    title="Детайли за проблем с прехвърлените данни"
    actions={<BackButtonToolbar />}
  >
    <SimpleShowLayout>
      <StudentInfoSection />
      <RequestInfoSection />
    </SimpleShowLayout>
  </Show>
);

export default ShowAcademicRequestDataIssue;
